document.addEventListener('DOMContentLoaded', function () {

  const sidebar = document.querySelector('.luxury-sidebar');
  const filterToggle = document.querySelector('.luxury-filter-toggle');
  const overlay = document.getElementById('luxury-sidebar-overlay');
  const closeBtn = document.getElementById('luxury-sidebar-close');
  const gridBtns = document.querySelectorAll('.luxury-grid-btn');
  const groupTitles = document.querySelectorAll('.luxury-sidebar__group-title');

  function openSidebar() {
    if (sidebar) sidebar.classList.add('is-open');
    if (filterToggle) filterToggle.classList.add('is-active');
    if (overlay && window.innerWidth < 750) overlay.classList.add('is-visible');
  }

  function closeSidebar() {
    if (sidebar) sidebar.classList.remove('is-open');
    if (filterToggle) filterToggle.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-visible');
  }

  if (filterToggle) {
    filterToggle.addEventListener('click', function () {
      sidebar && sidebar.classList.contains('is-open') ? closeSidebar() : openSidebar();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeSidebar();
    });
  }

  if (overlay) overlay.addEventListener('click', closeSidebar);

  groupTitles.forEach(function (title) {
    title.classList.add('is-open');
    title.nextElementSibling.classList.add('is-open');
    title.addEventListener('click', function () {
      title.classList.toggle('is-open');
      title.nextElementSibling.classList.toggle('is-open');
    });
  });

  function applyColumns(cols) {
    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;

    productGrid.classList.remove('cols-1', 'cols-2', 'cols-3', 'cols-4');
    productGrid.classList.add('cols-' + cols);

    const oldStyle = document.getElementById('luxury-grid-override');
    if (oldStyle) oldStyle.remove();

    const style = document.createElement('style');
    style.id = 'luxury-grid-override';

    if (window.innerWidth < 750) {
      style.innerHTML = cols === 1
        ? `ul#product-grid.cols-1 .grid__item { width:100%!important; max-width:100%!important; flex:0 0 100%!important; }`
        : `ul#product-grid.cols-2 .grid__item { width:calc(50% - 2px)!important; max-width:calc(50% - 2px)!important; flex:0 0 calc(50% - 2px)!important; }`;
    } else {
      productGrid.className = productGrid.className.replace(/grid--\d+-col-desktop/g, '');
      const gap = parseFloat(getComputedStyle(productGrid).columnGap) || 4;
      const totalGap = gap * (cols - 1);
      style.innerHTML = `
        @media screen and (min-width: 750px) {
          ul#product-grid.cols-${cols} .grid__item {
            width: calc((100% - ${totalGap}px) / ${cols}) !important;
            max-width: calc((100% - ${totalGap}px) / ${cols}) !important;
            flex: 0 0 calc((100% - ${totalGap}px) / ${cols}) !important;
          }
        }`;
    }
    document.head.appendChild(style);
  }

  const defaultCols = window.innerWidth < 750 ? 2 : 4;
  const defaultBtn = document.querySelector(`.luxury-grid-btn[data-cols="${defaultCols}"]`);
  if (defaultBtn) defaultBtn.classList.add('is-active');
  applyColumns(defaultCols);

  gridBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const cols = parseInt(btn.getAttribute('data-cols'));
      gridBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      applyColumns(cols);
    });
  });

  const filterCheckboxes = document.querySelectorAll('.luxury-sidebar__option input[type="checkbox"]');
  filterCheckboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      if (checkbox.checked) {
        params.append(checkbox.name, checkbox.value);
      } else {
        const existing = params.getAll(checkbox.name).filter(v => v !== checkbox.value);
        params.delete(checkbox.name);
        existing.forEach(v => params.append(checkbox.name, v));
      }
      window.location.href = url.toString();
    });
  });

});